import PositionIndex from './views/index';
import PositionNew from './views/new';
import PositionEdit from './views/edit';
import PositionCompare from './views/compare';
import PositionEvaluations from './views/evaluations';
import PositionTeamFit from './views/teamFit';


export default [
    {
        path: '/positions',
        name: 'PositionIndex',
        component: PositionIndex,
        meta: {layout: "layoutUser", pageOrder: 3, pageSubOrder: 1}
    },
    {
        path: '/positions/new',
        name: 'PositionNew',
        component: PositionNew,
        meta: {layout: "layoutUser", pageOrder: 3, pageSubOrder: 2, isProtected: true, feature: 'create_sight_group'}
    },
    {
        path: '/positions/:id',
        name: 'PositionEdit',
        component: PositionEdit,
        meta: {layout: "layoutUser", pageOrder: 3, pageSubOrder: 2}
    },
    {
        path: '/positions/compare/:id',
        name: 'PositionCompare',
        component: PositionCompare,
        meta: {layout: "layoutUser", pageOrder: 3, pageSubOrder: 2}
    },
    {
        path: '/positions/:id/evaluations',
        name: 'PositionEvaluations',
        component: PositionEvaluations,
        meta: {layout: "layoutUser", pageOrder: 3, pageSubOrder: 2}
    },
    {
        path: '/positions/:id/team_fit',
        name: 'PositionTeamFit',
        component: PositionTeamFit,
        meta: {layout: "layoutUser", pageOrder: 3, pageSubOrder: 2}
    }
];